export default "__VITE_ASSET__c4883102__"